import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _typeof from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/typeof.js";
import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { format, parseISO } from "date-fns";
import { apiClient } from "@/services/api-client";
import { lettersBeforeNumbers } from "@/utils/sort";
var personName = function personName(p) {
  return [p === null || p === void 0 ? void 0 : p.prefix, p === null || p === void 0 ? void 0 : p.given, p === null || p === void 0 ? void 0 : p.middle, p === null || p === void 0 ? void 0 : p.family].filter(Boolean).join(" ").trim();
};
var personNames = function personNames(people) {
  return (people !== null && people !== void 0 ? people : []).map(personName).filter(Boolean);
};
var formatVersionDate = function formatVersionDate(iso) {
  if (!iso) return "";
  try {
    return format(parseISO(iso), "MMM d, yyyy");
  } catch (_unused) {
    return "";
  }
};
var mapVersion = function mapVersion(v) {
  var _v$order_metadata, _v$report_metadata, _v$visit_metadata, _order$ordering_provi, _visit$referring_doct, _visit$patient_class, _v$additional_metadat, _v$version_id, _v$report_status;
  var order = (_v$order_metadata = v.order_metadata) !== null && _v$order_metadata !== void 0 ? _v$order_metadata : {};
  var report = (_v$report_metadata = v.report_metadata) !== null && _v$report_metadata !== void 0 ? _v$report_metadata : {};
  var visit = (_v$visit_metadata = v.visit_metadata) !== null && _v$visit_metadata !== void 0 ? _v$visit_metadata : {};
  var radiologists = [personName(report.principal_reporting_radiologist)].concat(_toConsumableArray(personNames(report.assistant_reporting_radiologists))).filter(Boolean);
  var metadata = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, order.accession_number ? {
    acc: order.accession_number
  } : {}), radiologists.length > 0 ? {
    radiologists: radiologists
  } : {}), (_order$ordering_provi = order.ordering_providers) !== null && _order$ordering_provi !== void 0 && _order$ordering_provi[0] ? {
    ordering: personName(order.ordering_providers[0])
  } : {}), (_visit$referring_doct = visit.referring_doctors) !== null && _visit$referring_doct !== void 0 && _visit$referring_doct[0] ? {
    referring: personName(visit.referring_doctors[0])
  } : {}), (_visit$patient_class = visit.patient_class) !== null && _visit$patient_class !== void 0 && _visit$patient_class.display ? {
    patientClass: visit.patient_class.display
  } : {});
  var additional = {};
  Object.entries((_v$additional_metadat = v.additional_metadata) !== null && _v$additional_metadat !== void 0 ? _v$additional_metadat : {}).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (value != null && _typeof(value) === "object" && !Array.isArray(value)) return;
    var str = String(value !== null && value !== void 0 ? value : "").trim();
    if (str) additional[key] = str;
  });
  return _objectSpread({
    id: String((_v$version_id = v.version_id) !== null && _v$version_id !== void 0 ? _v$version_id : ""),
    label: (_v$report_status = v.report_status) !== null && _v$report_status !== void 0 ? _v$report_status : "",
    date: formatVersionDate(report.report_observation_datetime || v.created_at || v.updated_at),
    reportHtml: v.highlighted_report || v.report_text || "",
    metadata: metadata,
    additional: additional
  }, v.custom_tags ? {
    custom_tags: v.custom_tags
  } : {});
};

/** Fetches a patient's reports sorted by heading, mapping version content and custom_tags. */
export function fetchPatientReports(_x) {
  return _fetchPatientReports.apply(this, arguments);
}

/** Uploads a free-text report for a patient, returning the created report. */
function _fetchPatientReports() {
  _fetchPatientReports = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(patientUid) {
    var _data$results;
    var _yield$apiClient$get, data, results;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return apiClient.get("/patients/".concat(patientUid, "/reports/"));
        case 1:
          _yield$apiClient$get = _context.v;
          data = _yield$apiClient$get.data;
          results = (_data$results = data.results) !== null && _data$results !== void 0 ? _data$results : [];
          return _context.a(2, _toConsumableArray(results).sort(function (a, b) {
            var _a$heading, _b$heading;
            return lettersBeforeNumbers((_a$heading = a.heading) !== null && _a$heading !== void 0 ? _a$heading : "", (_b$heading = b.heading) !== null && _b$heading !== void 0 ? _b$heading : "");
          }).map(function (r) {
            var _r$versions;
            return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
              id: r.id,
              heading: r.heading
            }, r.modality ? {
              modality: r.modality
            } : {}), r.exam_observation_datetime ? {
              examDate: formatVersionDate(r.exam_observation_datetime)
            } : {}), r.study_id != null ? {
              studyId: r.study_id
            } : {}), r.updated_at !== undefined ? {
              updated_at: r.updated_at
            } : {}), {}, {
              versions: ((_r$versions = r.versions) !== null && _r$versions !== void 0 ? _r$versions : []).slice().reverse().map(mapVersion)
            });
          }));
      }
    }, _callee);
  }));
  return _fetchPatientReports.apply(this, arguments);
}
export function uploadReport(_x2, _x3, _x4) {
  return _uploadReport.apply(this, arguments);
}

/** Links an uploaded report to a study by accession number. */
function _uploadReport() {
  _uploadReport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(workspaceId, patientUid, report) {
    var _yield$apiClient$post, data;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return apiClient.post("/workspaces/".concat(workspaceId, "/patient/").concat(patientUid, "/upload_report/"), {
            report: report
          });
        case 1:
          _yield$apiClient$post = _context2.v;
          data = _yield$apiClient$post.data;
          return _context2.a(2, data);
      }
    }, _callee2);
  }));
  return _uploadReport.apply(this, arguments);
}
export function linkStudyToReport(_x5, _x6, _x7, _x8) {
  return _linkStudyToReport.apply(this, arguments);
}
function _linkStudyToReport() {
  _linkStudyToReport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(workspaceId, patientUid, reportId, accessionNumber) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return apiClient.post("/workspaces/".concat(workspaceId, "/patient/").concat(patientUid, "/link_study_with_report/"), {
            report_id: reportId,
            accession_number: accessionNumber
          });
        case 1:
          return _context3.a(2);
      }
    }, _callee3);
  }));
  return _linkStudyToReport.apply(this, arguments);
}